<template>
  <div id="addcreditSection">
    <div class="content bg-blue-grey-100 p-30">
      <div class="row">
        <div class="col-md-12 col-xs-12 m-b-10">
          <p class="font-size-16">{{ $t("billing.addcredit.labels.textGuide") }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <form-group>
            <select class="form-control form-control-lg" v-model="currentPrice">
              <option v-for="(item, index) in priceList" v-bind:value="item">{{item.key}}
              <span v-if="item.key !== 'Custom'">{{ $t("billing.currencies.thb") }}</span>
              </option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12" v-if="currentPrice.key === 'Custom'">
          <form-group v-bind:error="formErrors.first('customPrice')">
            <div class="input-group">
              <input type="number" class="form-control form-control-lg" autocomplete="off" v-model="currentPrice.value" />
              <span class="input-group-addon">{{ $t("billing.currencies.thb") }}</span>
            </div>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="help-guide grey-500">
            <span class="red-600">*</span> {{ $t("billing.addcredit.labels.remark") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12 m-t-15">
          <button class="btn btn-success btn-block btn-lg text-uppercase"
            v-bind:disabled="formErrors.first('customPrice')"
            type="button"
            v-on:click="onPayButtonClick">
            <i class="icon md-lock" aria-hidden="true"></i> {{ $t("billing.action.pay") }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12 m-t-20">
          <div class="payment-logos">
            <img src="/static/images/omise.png" alt="Omise">
            <img class="pull-xs-right" src="/static/images/creditcard.png" alt="Mc visa acceptance">
          </div>
        </div>
      </div>
    </div>
    <modal ref="paymentInformationFormModal" class="modal-primary">
      <h4 slot="title" class="modal-title">{{ $t("billing.labels.paymentInformation") }}</h4>
        <payment-information-form
          slot="body"
          ref="paymentInformationForm"
          v-bind:team="team"
          v-bind:credit="selectedCredit"
          v-on:complete="onPaymentInformationFormComplete"
          v-on:cancel="onPaymentInformationFormCancel">
        </payment-information-form>
    </modal>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';
import swal from 'sweetalert2';
import Alert from 'components/Alert';
import Modal from 'components/Modal';
import FormGroup from 'components/forms/FormGroup';
import PaymentInformationForm from 'components/forms/PaymentInformationForm';
import { loadPriceList } from 'src/modules/api/credit';

export default {
  components: {
    Alert,
    Modal,
    FormGroup,
    PaymentInformationForm,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    'currentPrice.value': function(value) {
      if (this.currentPrice.key === 'Custom') {
        // validate custom value
        this.validator.validateAll({
          customPrice: value,
        }).then((success) => {
          if (!success) {
            return;
          }

          this.selectedCredit = value;
        }).catch(() => {});
      } else {
        this.selectedCredit = value;
      }
    },
  },
  computed: {

  },
  data: function() {
    return {
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      currentPrice: { value: 300, key: '300' },
      priceList: null,
      selectedCredit: 300,
    };
  },
  created: function() {
    this.validator = new Validator();
    this.validator.attach('customPrice', 'required|numeric|custom_price_between:300,100000', { prettyName: 'Custom Credit' });

    this.validator.errorBag.errors = [];
    this.$set(this, 'formErrors', this.validator.errorBag);
    this.loadPriceList();
  },
  mounted: function() {
    if (this.$route.query.result) {
      this.resultPayment(this.$route.query.result);
    }
  },
  methods: {
    loadPriceList () {
      this.priceList = loadPriceList();
    },
    onPayButtonClick: function() {
      this.$refs.paymentInformationForm.clearForm();
      this.$refs.paymentInformationFormModal.open();
    },
    onPaymentInformationFormComplete: function() {
    },
    onPaymentInformationFormCancel: function() {
      this.$refs.paymentInformationFormModal.close();
    },
    resultPayment: function (action) {
      if (action === 'success') {
        swal(
          this.$t('billing.addcredit.paymentResult.success.title'),
          this.$t('billing.addcredit.paymentResult.success.text'),
          'success'
        ).then(() => {
          this.$router.replace(this.$route.path);
        });
      } else {
        swal(
          this.$t('billing.addcredit.paymentResult.failed.title'),
          this.$t('billing.addcredit.paymentResult.failed.text'),
          'error'
        ).then(() => {
          this.$router.replace(this.$route.path);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.help-guide {
  ul {
    padding-left: 20px;
  }
}

.enter-billing-information-text {
  a {
    text-decoration: underline;
  }
}

.form-group {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// BillingCreditOmise.vue?40f9072c